import * as React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';

import { cn } from '../../utils';
import { ComponentPropsWithoutRef } from 'react';

interface Props extends ComponentPropsWithoutRef<typeof AvatarPrimitive.Root> {
  firstName?: string | null;
  lastName?: string | null;
  src?: string | null;
}

export const UserDisplayAvatar = ({
  firstName,
  lastName,
  src,
  className = '',
  ...props
}: Props) => {
  return (
    <Avatar
      className={cn(
        'h-32 w-32 rounded-full overflow-hidden shadow-lg ext-4xl',
        className
      )}
      {...props}
    >
      {src ? (
        <AvatarImage src={src} className="object-cover" />
      ) : (
        <AvatarFallback className="flex t bg-background">
          {firstName?.charAt(0)}
          {lastName?.charAt(0)}
        </AvatarFallback>
      )}
    </Avatar>
  );
};

const Avatar = React.forwardRef<
  React.ElementRef<typeof AvatarPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root>
>(({ className, ...props }, ref) => (
  <AvatarPrimitive.Root
    ref={ref}
    className={cn(
      'relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full',
      className
    )}
    {...props}
  />
));
Avatar.displayName = AvatarPrimitive.Root.displayName;

const AvatarImage = React.forwardRef<
  React.ElementRef<typeof AvatarPrimitive.Image>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Image>
>(({ className, ...props }, ref) => (
  <AvatarPrimitive.Image
    ref={ref}
    className={cn('aspect-square h-full w-full object-cover', className)}
    {...props}
  />
));
AvatarImage.displayName = AvatarPrimitive.Image.displayName;

const AvatarFallback = React.forwardRef<
  React.ElementRef<typeof AvatarPrimitive.Fallback>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Fallback>
>(({ className, ...props }, ref) => (
  <AvatarPrimitive.Fallback
    ref={ref}
    className={cn(
      'flex h-full w-full items-center justify-center rounded-full bg-muted',
      className
    )}
    {...props}
  />
));
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

export { Avatar, AvatarImage, AvatarFallback };
